import { Component, Input } from '@angular/core';

@Component({
    selector: 'form-label',
    styleUrls: ['formlabel.component.css'],
    templateUrl: 'formlabel.component.html'
})
export class FormLabelComponent {
    @Input('label-text') LabelText : string;
    @Input() required : boolean;
}


// WEBPACK FOOTER //
// ./src/app/ui/formlabel/formlabel.component.ts